export default "<h3 class=\"{{ statusClass }}\">{{ statusLabel }}</h3>\n"